"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPagePartTable = void 0;
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _react = _interopRequireDefault(require("react"));
var _DmsAltBox = require("../../components/DmsAltBox/DmsAltBox");
var _DmsPage = require("../../components/DmsPage/DmsPage");
var _DmsPartTable = require("../../components/DmsPartTable/DmsPartTable");
var _material = require("@mui/material");
var _DmsPartParameterTable = require("../../components/DmsPartParameter/DmsPartParameterTable");
var _DmsTabber = require("../../components/DmsTabber/DmsTabber");
var _DmsPartCompositionTable = require("../../components/DmsPartCompositionTable/DmsPartCompositionTable");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsPagePartTable Component
 * @component
 * @description Represents the page for viewing parts within a Document Management System (DMS).
 * @returns {JSX.Element} The JSX element rendering the parts management page.
 */
const DmsPagePartTable = () => {
  const tabs = [{
    title: _reactIntlUniversal.default.get("Part").d("Part"),
    component: /*#__PURE__*/_react.default.createElement(_DmsPartTable.DmsPartTable, null)
  }, {
    title: _reactIntlUniversal.default.get("PartParameter").d("Part parameter"),
    component: /*#__PURE__*/_react.default.createElement(_DmsPartParameterTable.DmsPartParameterTable, null)
  }, {
    title: _reactIntlUniversal.default.get("PartComposition").d("Part Composition"),
    component: /*#__PURE__*/_react.default.createElement(_DmsPartCompositionTable.DmsPartCompositionTable, null)
  }];
  return /*#__PURE__*/_react.default.createElement(_DmsPage.DmsPage, {
    name: "Part"
  }, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Card, null, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Header, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    sx: {
      fontSize: '1.1rem'
    }
  }, _reactIntlUniversal.default.get("Part").d("Part"))), /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Body, null, /*#__PURE__*/_react.default.createElement(_DmsTabber.DmsTabber, {
    tabs: tabs
  }))));
};
exports.DmsPagePartTable = DmsPagePartTable;